export default __webpack_public_path__ + "static/media/Group-6-Yono-mitc@2x.8123b873.png";